{
  "version": 1,
  "asset_id": "66c2ab43-d571-4bd6-943f-67f4ad3d562d",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/66c2ab43-d571-4bd6-943f-67f4ad3d562d/svc-local-seo-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/66c2ab43-d571-4bd6-943f-67f4ad3d562d/svc-local-seo-640.webp",
  "original_filename": "svc-local-seo-640.webp",
  "size": 6458,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:54Z"
}
